<template>
    <Skeleton v-if="data.isLoading" />
    <object v-if="!data.isLoading && data.ticket" class="tableauViz" :width="width" :height="height" style="display: none">
        <param name="host_url" :value="hostUrl" />
        <param name="embed_code_version" value="3" />
        <param name="site_root" value="" />
        <param name="name" :value="address" />
        <param name="tabs" value="no" />
        <param name="toolbar" :value="toolbar" />
        <param name="showAppBanner" value="false" />
        <param name="filter" value="iframeSizedToWindow=true" />
        <param name="ticket" :value="data.ticket" />
    </object>
    <div v-if="!data.isLoading && isDebug" class="mt-3 mb-3">
        <Tag color="blue" class="mx-0 ml-2">address = {{ address }}</Tag>
        <Tag color="blue" class="mx-0 ml-2">hostUrl = {{ hostUrl }}</Tag>
        <Tag color="blue" class="mx-0 ml-2">data.ticket = {{ data.ticket }}</Tag>
    </div>
</template>

<script>
    import { Tag, Skeleton } from "ant-design-vue";
    import { reactive } from "vue";
    import { useStore } from "vuex";

    export default {
        components: {
            Tag,
            Skeleton
        },
        props: {
            address: { default: "test1/Sheet1" },
            toolbar: { default: "yes" },
            width: { default: 1280 },
            height: { default: 827 },
            isDebug: { default: true },
        },
        setup() {
            const data = reactive({ ticket: null, isLoading: false });
            const store = useStore();
            const hostUrl = `${process.env.VUE_APP_TABLEAU_URL}/`;
            data.isLoading = true;
            store.dispatch("resource/tableau/trusted", {}).then((ticket) => (data.ticket = ticket)).then(() => {
                const plugin = document.createElement("script");
                plugin.setAttribute("src", `${process.env.VUE_APP_TABLEAU_URL}/javascripts/api/viz_v1.js`);
                plugin.async = true;
                document.head.appendChild(plugin);
            }).finally(() => {
                data.isLoading = false;
            });
            return { data, hostUrl };
        },
    }
</script>